// src/components/faq/institutionalFAQ.jsx

const institutionalFaqItems = [
  {
    question: 'What are All-Voiced Institutional Programs?',
    answer:
      'All-Voiced Institutional Programs are configured educational implementations for universities, courses, clinical teams, professional organizations, continuing education programs, and research groups. They can connect structured listening activities with course integration, assessment, learning analytics, competency evidence, cohort workflows, and educational research.',
  },
  {
    question: 'How do Institutional Programs differ from Perceptual Skill Development?',
    answer:
      'Perceptual Skill Development focuses on how individuals and groups develop auditory-perceptual expertise through available activities and Live Sessions. Institutional Programs configure these and other capabilities within courses, cohorts, assessment models, learning analytics, educational research, or broader institutional implementation.',
  },
  {
    question: 'Are Institutional Programs the same as a license or a fixed product?',
    answer:
      'No. An Institutional Program is not a single fixed package. Its implementation, access model, collaboration structure, and pricing depend on the institution’s goals, participants, required capabilities, and scope.',
  },
  {
    question: 'What is the simplest way to start?',
    answer:
      'The simplest starting point is often a focused course integration, demonstration, or small pilot using existing All-Voiced activities. The institution can then decide whether it needs a custom module, cohort workflow, assessment model, learning analytics, educational research support, or a broader program implementation.',
  },
  {
    question: 'What implementation models are possible?',
    answer:
      'Common models include focused activity use, course integration, custom educational modules, cohort or program implementation, continuing education, blended or hybrid learning, and educational research. Demonstrations or pilots may be used before a broader implementation is defined.',
  },
  {
    question: 'Can All-Voiced support learning analytics and competency evidence?',
    answer:
      'Potentially. Learning analytics, reporting, feedback, progress monitoring, and competency evidence can be configured where supported by the selected activities, data model, implementation scope, and educational objectives.',
  },
  {
    question: 'Can Institutional Programs support educational research?',
    answer:
      'Yes. Educational research may be included when All-Voiced is used to support learning studies, teaching innovation, structured data generation, evidence building, or publication-oriented work. The research workflow and outputs must be defined as part of the implementation scope.',
  },
  {
    question: 'Can we begin with a demo or pilot?',
    answer:
      'Yes. A demonstration, trial, or small pilot may help an institution understand how All-Voiced fits its educational context before defining a larger course, cohort, or program implementation. The appropriate format depends on the objective, participants, and available resources.',
  },
  {
    question: 'Do we need to define a full institutional program from the beginning?',
    answer:
      'No. Many collaborations begin with a small, clearly scoped implementation. A broader institutional program can emerge later if the initial activity creates value and the institution decides to expand.',
  },
  {
    question: 'How are pricing and access determined?',
    answer:
      'Some existing All-Voiced activities are available free of charge. Configured modules, analytics, reporting, cohort workflows, demonstrations, co-development, or broader institutional implementations are scoped separately according to the required capabilities, support, access model, and institutional context.',
  },
  {
    question: 'Can an institution co-develop a program with All-Voiced?',
    answer:
      'Yes. Institutional work may be delivered by All-Voiced, co-developed with partners, or configured collaboratively with an institution using All-Voiced as shared educational infrastructure. The partnership model, implementation model, and commercial terms are defined separately.',
  },
  {
    question: 'What should we prepare before a conversation?',
    answer:
      'Helpful starting points include the learner or evaluator group, course or program context, educational or research objectives, intended scope, assessment and reporting needs, timeline, and whether the institution is considering a demonstration, pilot, module, cohort workflow, or broader program.',
  },
];

export default function InstitutionalFAQ() {
  return (
    <section
      className="service-landing-section service-landing-faq"
      aria-labelledby="institutional-faq-title"
    >
      <span className="services-label">
        FAQ
      </span>

      <h2 id="institutional-faq-title">
        Institutional Programs FAQ
      </h2>

      <p>
        Common questions about configured educational implementation,
        course and cohort use, learning analytics, educational research,
        access, and collaboration.
      </p>

      <div className="service-landing-faq-list">
        {institutionalFaqItems.map((item) => (
          <details className="service-landing-faq-item" key={item.question}>
            <summary>
              <span>{item.question}</span>
            </summary>

            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
